/**
 * `data-testid` values for the upload modal file table (`UploadFilesModal` / `FilesTable`).
 * Patient files use `available-files-row-*` from `GeneralTable` (`id="available-files"`).
 */

export function uploadModalAvailableFilesRowTestId(
  fileId: string | number,
): string {
  return `upload-modal-available-files-row-${fileId}`;
}

export function uploadModalUnavailableFilesRowTestId(
  fileId: string | number,
): string {
  return `upload-modal-unavailable-files-row-${fileId}`;
}
